

import { createSlice } from '@reduxjs/toolkit';

const LoadingSlice = createSlice({
    name: 'loading',
    initialState: {
        loading: false
    },
    reducers: {
        setLoading(state, action) {
            state.loading = action.payload;
        }
    },
});

export const LoadingActions = LoadingSlice.actions;

export default LoadingSlice;